import { deClientPortalValuationDCFPage } from './Valuation/ValuationDCF/ValuationDCFPage'
import { deClientPortalValuationIncomePage } from './Valuation/ValuationIncomePage/ValuationIncomePage'
import { deClientPortalValuationPageLayout } from './Valuation/ValuationLayout/ValuationPageLayout'
import { deClientPortalValuationMarketData } from './Valuation/ValuationMarketData'
import { deClientPortalValuationPlausibility } from './Valuation/ValuationPlausibility'
import { deClientPortalValuationTenantListPage } from './Valuation/ValuationTenantList/ValuationTenantListPage'
import { deClientPortalValuationOverviewCommon } from './Valuation/ValuationOverview'

export const deClientPortalValuationCommon = {
    valuationPageLayout: deClientPortalValuationPageLayout,
    valuationOverview: deClientPortalValuationOverviewCommon.valuationOverview,
    valuationIncomePage: deClientPortalValuationIncomePage,
    valuationTenantListPage: deClientPortalValuationTenantListPage,
    valuationDCFPage: deClientPortalValuationDCFPage,
    valuationMarketData: deClientPortalValuationMarketData,
    valuationPlausibility: deClientPortalValuationPlausibility,
}
